import { createApp, defineAsyncComponent, ref, h } from 'vue'

const TipTapEditorAsync = defineAsyncComponent(() =>
  import('./components/TipTap/TipTapEditor.vue')
)

const initEditor = (element) => {
  const content = ref(element.value || '')

  const app = createApp({
    setup() {
      return () => h(TipTapEditorAsync, {
        modelValue: content.value,
        'onUpdate:modelValue': (val) => {
          content.value = val
          element.value = val
        },
        placeholder: element.dataset.placeholder || ''
      })
    }
  })

  const wrapper = document.createElement('div')
  wrapper.className = 'tiptap-wrapper'
  element.parentNode.insertBefore(wrapper, element.nextSibling)
  element.style.display = 'none'

  app.mount(wrapper)

  return app
}

document.querySelectorAll('.ckeditor').forEach((element) => {
  initEditor(element)
})
